import { render, staticRenderFns } from "./NewPerformances.vue?vue&type=template&id=b6a624c0&scoped=true"
import script from "./NewPerformances.vue?vue&type=script&lang=js"
export * from "./NewPerformances.vue?vue&type=script&lang=js"
import style0 from "./NewPerformances.vue?vue&type=style&index=0&id=b6a624c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a624c0",
  null
  
)

export default component.exports